import { lockBody, unlockBody } from '../utils'


const openBtn = document.querySelector('.js-open-mobile-navigation');
const closeBtn = document.querySelector('.js-close-mobile-navigation');
const mobileNav = document.querySelector('.js-mobile-nav');

function toggleHeight(el) {
    if (!el) return;

    const isHidden = el.offsetHeight === 0;

    if (isHidden) {
        el.style.display = 'block';
        const height = el.scrollHeight + 'px';
        el.style.height = '0px';

        requestAnimationFrame(() => {
            el.style.transition = 'height 0.3s ease';
            el.style.height = height;
        });

        el.addEventListener('transitionend', function handler() {
            el.style.height = 'auto';
            el.removeEventListener('transitionend', handler);
        });

    } else {
        el.style.height = el.scrollHeight + 'px';

        requestAnimationFrame(() => {
            el.style.transition = 'height 0.3s ease';
            el.style.height = '0px';
        });

        el.addEventListener('transitionend', function handler() {
            el.style.display = 'none';
            el.removeEventListener('transitionend', handler);
        });
    }
}

openBtn?.addEventListener('click', () => {
    toggleHeight(mobileNav);
    lockBody();
});

closeBtn?.addEventListener('click', () => {
    toggleHeight(mobileNav);
    unlockBody();
});